import { useState } from "react";
import CarouselAndAudioPlayer from "../CarouselAndAudioPlayer/CarouselAndAudioPlayer";
import PreviewBar from "../PreviewBar/PreviewBar";
import TrackProgress from "../TrackProgress/TrackProgress";
// import { RedirectIcon } from "../../Assets/assets";
import { capitalizeFirstLetter, Fields } from "../../Utils/Constants/Constants";
import { ArrowIcon } from "../../Assets/assets";

function ProcedureHistoryPreview(props) {
  const [showRequiredRemarks, setShowRequiredRemarks] = useState(null);

  return (
    <>
      <PreviewBar
        onCloseClick={() => {
          props.navigate("/locations/procedureHistory");
        }}
        title={
          <div className="display-flex flex-align-items-center">
            <div
              className="font-color-tertiaryColor font-size-larger"
              data-cy={`preview-document-${props.data?.documentId}`}
            >
              {capitalizeFirstLetter(props.data?.procedure?.title)}
            </div>
            <div
              style={{
                color: "var(--secondaryColor)"
              }}
              className="padding-left-default font-size-small text-uppercase"
              data-cy={`preview-employee-type-${props.data?.employee?.type}`}
            >
              {props.data?.employee?.type}
            </div>
          </div>
        }
        description={`${props.data?.location?.PCTNo} - ${props.data?.location?.address}`}
        data-cy="preview-bar-container"
      >
        <div
          className="padding-bottom-large font-size-small"
          style={{ borderBottom: "2px solid var(--tertiaryColor3)" }}
          data-cy="preview-header-section"
        >
          <Fields
            title="CREATED AT"
            data={props.data?.createdAt}
            dataCy="preview-created-at"
          />
          <Fields
            title="COMPLETED BY"
            data={`${props.data?.employee?.name}, ${props.data?.employee?.phoneNumber}`}
            dataCy="preview-completed-by"
          />
          <div className="display-flex flex-align-items-center">
            <Fields
              title="LOCATION"
              data={`${props.data?.location?.PCTNo} - ${props.data?.location?.address}`}
              dataCy="preview-location"
            />
            {/* <div
              className="margin-left-default padding-top-large"
              data-cy="preview-location-redirect"
            >
              <RedirectIcon color="var(--tertiaryColor6)" />
            </div> */}
          </div>
          {props.data?.latestUpdate?.some((data) => data?.kpi?.final) ? (
            <Fields
              title="KPI SCORE"
              data={props.data?.latestUpdate?.reduce(
                (sum, data) => data?.kpi?.final ? sum + data?.kpi?.final : sum,
                0
              )}
              dataCy="preview-kpi-score"
            />
          ) : (
            <></>
          )}
        </div>
        <div className="margin-top-larger">
          <div
            className="margin-bottom-large font-color-tertiaryColor6"
            data-cy="preview-steps-header"
          >
            STEPS
          </div>
          {props.data?.latestUpdate.map((update, index) => (
            <TrackProgress
              key={index}
              state={update.success ? "ACTIVE" : "FAILED"}
              title={update.title}
              isLast={
                index === props.data?.latestUpdate.length - 1 ? true : false
              }
              data={
                <>
                  <div className="font-color-tertiaryColor6 padding-bottom-medium">
                    {update.description}
                  </div>
                  {update.remarks ? (
                    <div className="font-color-tertiaryColor6 padding-bottom-default">
                      <strong>Remarks:</strong> {update.remarks}
                    </div>
                  ) : (
                    <> </>
                  )}
                  {update.kpi?.final &&
                  (!update.requiredRemarks ||
                    update.requiredRemarks?.length === 0) ? (
                    <div className="font-color-tertiaryColor6 padding-bottom-medium">
                      KPI Score: {update.kpi.final}
                    </div>
                  ) : (
                    <></>
                  )}
                  {update.requiredRemarks?.length > 0 ? (
                    <div
                      className=" display-flex flex-justify-content-space-between flex-align-items-center padding-bottom-default cursor-pointer"
                      data-cy={`requiredRemarks-${index}-${
                        showRequiredRemarks === index ? "OPEN" : "CLOSED"
                      }`}
                      onClick={() => {
                        if (showRequiredRemarks === index) {
                          setShowRequiredRemarks(null);
                        } else {
                          setShowRequiredRemarks(index);
                        }
                      }}
                    >
                      <div
                        className="font-color-tertiaryColor6 font-size-medium "
                        style={{ fontWeight: "600" }}
                      >
                        {`Question & Responses : ${update.requiredRemarks?.length}`}
                      </div>

                      <div
                        className=" display-flex flex-justify-content-space-between flex-align-items-center"
                        style={{
                          transform:
                            showRequiredRemarks === index
                              ? "rotate(180deg)"
                              : ""
                        }}
                      >
                        <ArrowIcon />
                      </div>
                    </div>
                  ) : (
                    <> </>
                  )}
                  {update.requiredRemarks?.length > 0 &&
                  showRequiredRemarks === index ? (
                    <div className=" padding-left-larger">
                      {update.requiredRemarks.map((remark) => (
                        <div className=" padding-bottom-default">
                          <div className=" font-color-tertiaryColor6">
                            {remark.title}
                          </div>
                          <div className=" font-color-tertiaryColor padding-top-small">
                            {remark.value}
                          </div>
                          {remark.kpi?.final ? (
                            <div className=" font-color-tertiaryColor padding-top-small">
                              KPI Score: {remark.kpi.final}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <> </>
                  )}
                  <div className="inherit-parent-width padding-top-default">
                    <CarouselAndAudioPlayer
                      assetsLoading={props.assetsLoading}
                      setCroppedImage={props.setCroppedImage}
                      fileSrc={update.fileSrc}
                      onImageClick={(data) => {
                        if (typeof props.setPreviewImage === "function") {
                          props.setPreviewImage(data);
                        }
                      }}
                    />
                  </div>
                </>
              }
            />
          ))}
        </div>
      </PreviewBar>
    </>
  );
}
export default ProcedureHistoryPreview;
